import React from "react"
import { Twitter, Facebook, Linkedin, ArrowRight } from "lucide-react"
import Header from "../components/Header"
import Footer from "../components/Footer"

const AboutUsSection = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Patrick Smith",
      role: "Co-founder",
      description: "Ex-corporate drone, now a full-time meeting avoider.",
      avatar:
        "https://media.licdn.com/dms/image/v2/C4E03AQGbyUE-T-uQlQ/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1517635812966?e=1761177600&v=beta&t=AR6jq9C-kPKCsMspyt0eLSREho5HdkXMWAIawzN9uRE",
      social: {
        twitter: "#",
        facebook: "#",
        linkedin: "#",
      },
    },
    {
      id: 2,
      name: "Nicolai",
      role: "Co-founder",
      description: "Hello, I like not doing anything at all. Let's DM",
      avatar:
        "https://media.licdn.com/dms/image/v2/C4E03AQH0VnXYPgVXzA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1572517093446?e=1761177600&v=beta&t=BwdWsU7TMB6ItDDmxe5RSUaORQs7uFEEUTw2rK7KFSI",
      social: {
        twitter: "#",
        facebook: "#",
        linkedin: "#",
      },
    },
    {
      id: 3,
      name: "Jon Percy",
      role: "Lead Engineering",
      description: "Prodigy with record breaking 10 IQ and many awards.",
      avatar:
        "https://media.licdn.com/dms/image/v2/D4E03AQH7NBSFIwjaKw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1722767526898?e=1760572800&v=beta&t=kNag6JW6rYLYWiVpXyO1ZZIA2PYSm5WhajVAUJQwCq4",
      social: {
        twitter: "#",
        facebook: "#",
        linkedin: "#",
      },
    },
    {
      id: 4,
      name: "Matthew Anton",
      role: "Lead Product",
      description: "Hello, I like money. It is the only purpose of my life.",
      avatar:
        "https://media.licdn.com/dms/image/v2/D5603AQFYzf_6yXTfVw/profile-displayphoto-shrink_400_400/B56ZRBUHlrGsAo-/0/1736262581814?e=1760572800&v=beta&t=GicSOAuPd2eNbNf5K7xbuLKXDspz7TjiI1UsFW6VmfI",
      social: {
        twitter: "#",
        facebook: "#",
        linkedin: "#",
      },
    },
  ]

  return (
    <div className="min-h-screen bg-white font-satoshi">
      <Header />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        {/* Meet Our Team Section */}
        <div className="text-center mb-20">
          <p className="text-blue-600 font-medium mb-4">We're Hiring!</p>
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Let's Meet Our Team
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto mb-12 text-lg leading-relaxed">
            Powered by coffee, creativity, and way too many Slack emojis.
          </p>

          <div className="flex justify-center gap-4 mb-16">
            <button className="bg-gray-100 text-gray-700 px-8 py-3 rounded-full font-medium hover:bg-gray-200 transition-colors">
              About Us
            </button>
            <button className="bg-purple-700 text-white px-8 py-3 rounded-full font-medium hover:bg-blue-700 transition-colors">
              Job Openings
            </button>
          </div>
        </div>

        {/* Team Grid - Minimalist Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-24">
          {teamMembers.map((member) => (
            <div key={member.id} className="text-center">
              <img
                src={member.avatar}
                alt={member.name}
                className="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 className="text-lg font-semibold text-gray-900 mb-1">
                {member.name}
              </h3>
              <p className="text-blue-600 font-medium text-sm mb-3">
                {member.role}
              </p>
              <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                {member.description}
              </p>

              <div className="flex justify-center space-x-3">
                <a
                  href={member.social.twitter}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <Twitter size={16} />
                </a>
                <a
                  href={member.social.facebook}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <Facebook size={16} />
                </a>
                <a
                  href={member.social.linkedin}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <Linkedin size={16} />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Join Our Team Section - Minimalist */}
        <div className="bg-blue-50 rounded-2xl p-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Join Our Team Now
              </h2>
              <p className="text-gray-600 leading-relaxed">
                Let’s build cool things (and laugh a lot doing it).
              </p>
            </div>

            <div className="flex justify-end">
              <div className="flex gap-4">
                <button className="bg-white text-blue-600 px-6 py-3 rounded-full font-medium border border-gray-200 hover:bg-gray-50 transition-colors flex items-center gap-2">
                  Learn More
                  <ArrowRight size={16} />
                </button>
                <button className="bg-purple-700 text-white px-6 py-3 rounded-full font-medium hover:bg-blue-700 transition-colors flex items-center gap-2">
                  Get Started
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default AboutUsSection
